import { BrowserRouter, Routes, Route } from "react-router-dom";
import { CartProvider } from "./state/CartContext";
import { LocationProvider } from "./state/LocationContext";
import { SheetProvider } from "./state/SheetContext";
import { AuthProvider } from "./state/AuthContext";
import { ItemSheet } from "./components/ItemSheet";
import Layout from "./components/Layout";
import AccountPage from "./pages/AccountPage";
import OrderTrackPage from "./pages/OrderTrackPage";
import HomePage from "./pages/HomePage";
import MenuPage from "./pages/MenuPage";
import CartPage from "./pages/CartPage";
import CheckoutPage from "./pages/CheckoutPage";
import ConfirmationPage from "./pages/ConfirmationPage";
import AdminPage from "./pages/admin/AdminPage";

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <LocationProvider>
          <CartProvider>
            <SheetProvider>
              <Routes>
                <Route element={<Layout />}>
                  <Route path="/" element={<HomePage />} />
                  <Route path="/menu" element={<MenuPage />} />
                  <Route path="/cart" element={<CartPage />} />
                  <Route path="/checkout" element={<CheckoutPage />} />
                  <Route path="/confirmation" element={<ConfirmationPage />} />
                  <Route path="/account" element={<AccountPage />} />
                  <Route path="/track" element={<OrderTrackPage />} />
                  <Route path="/track/:id" element={<OrderTrackPage />} />
                </Route>
                <Route path="/admin" element={<AdminPage />} />
              </Routes>
              <ItemSheet />
            </SheetProvider>
          </CartProvider>
        </LocationProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
